<template>
<div class="application-job" @click="click">
  <job-row-card :job="application" class="job" @click="click" />
  <div class="application-stats">
    <span class="stat">
      {{ application.appliedCount }}
      <heading class="small">Applied</heading>
    </span>
    <span class="stat">
        {{ application.interviewingCount }}
        <heading class="small">Interview</heading>
    </span>
    <span class="stat">
      {{ application.hiredCount }}
      <heading class="small">Hired</heading>
    </span>
  </div>
</div>
</template>

<script>
import JobRowCard from '@/components/jobs/job-row-card'
import Heading from '@/components/general/heading'
export default {
  components: { JobRowCard, Heading },
  props: {
    application: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    click (event) {
      this.$emit('click', event)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
.application-job {
  display: flex;
  background-color: white;
  border: 1px solid #ddd;
  background-color: white;
  &:hover {
    cursor: pointer;
    background-color: $hover-background;
  }
}

.application-stats {
  display: flex;
  justify-content: space-between;
  flex-shrink: 1;
  align-items: center;
  max-width: 300px;
  width: 300px;
  min-width: 200px;

  .stat {
    padding: 0 2.5rem;
    font-size: 2rem;
    max-width: 33%;
    flex: 1;
    .small {
      display: none;
    }
  }
}

.application-job:first-child {
  border-top-left-radius: $border-radius;
  border-top-right-radius: $border-radius;
  border: 1px solid #ddd;
}

.application-job:last-child {
  border-bottom-left-radius: $border-radius;
  border-bottom-right-radius: $border-radius;
}

.application-job:not(:last-child) {
  border-bottom: 0;
}

.job {
  background-color: transparent;
  border: 0;
  border-right: 1px solid $border-color;
  border-radius: 0;
  flex-grow: 1;
}

@media screen and (max-width: $tablet) {
  .application-job {
    display: block;
    margin-bottom: 1rem;
    border-bottom: 1px solid #ddd !important;
  }
  .job {
    width: 100%;
    border-right-width: 0px;
    padding: 0.5rem;
  }
  .application-stats {
    border-top: 1px solid #ddd;
    display: block;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    text-align: center;
    padding: 0.5rem;

    .stat {
      display: inline-block;
      padding: 0 1rem;
      text-align: center;

      .small {
        margin-top: 0.5rem;
        font-size: 0.7rem;
        display: block
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/applications/application-job-row-card.vue